import { ComponentProps, useRef } from 'react';
import { useIntl } from 'react-intl';

import Text from '../Text/Text';

type NumberValueProps = {
    value: number;
    hideDecimals?: boolean;
    customFormatter?: (value: number) => string;
} & Omit<ComponentProps<typeof Text>, 'ref'>;

const NumberValue = ({
    value,
    hideDecimals = false,
    customFormatter,
    ...textProps
}: NumberValueProps) => {
    const containerRef = useRef<HTMLSpanElement>(null);
    const intl = useIntl();

    const formatNumber =
        customFormatter ??
        ((value: number) => {
            return intl.formatNumber(value, {
                maximumFractionDigits: hideDecimals ? 0 : 2,
            });
        });

    return (
        <Text ref={containerRef} {...textProps}>
            {formatNumber(value)}
        </Text>
    );
};

export default NumberValue;
